/**
 * Нийтийн сайтын ТАБНЫ нэгдсэн хэлбэр.
 *
 * Өмнө нь табууд `ui/tabs`-ийн үндсэн хэлбэрээр (доогуур зураас, саарал
 * дэвсгэр) гардаг байсан нь админ панелийн харагдацтай ижил болж, танилцуулгын
 * хуудсанд тохирохгүй байв. Захиалагчийн өгсөн бөмбөлөг хэлбэрт шилжүүлэв.
 *
 * ⚠️ Өнгө нь ТОГТМОЛ (`#dec7ae` хүрээ, `#fbead8` цөцгий, хар бичиг) — theme-ийн
 * токен биш. Иймд харанхуй горимд ч цайвар бөмбөлөг хэвээр харагдана. Энэ нь
 * захиалагчийн шууд заасан утга тул зориуд өөрчлөөгүй.
 *
 * ⚠️ `dark:` хувилбаруудыг ЗААВАЛ бичсэн шалтгаан: `ui/tabs`-ийн үндсэн
 * дүрмүүд нь `dark:data-active:bg-input/30` гэх мэт ХОЁР хувилбартай тул
 * энгийн `bg-white`-аас илүү тодорхойлолттой болж дардаг. Тэнцүү жинтэй
 * бичихгүй бол харанхуй горимд өнгө огт хэрэглэгдэхгүй.
 */

/**
 * Табны эгнээ.
 *
 * Үндсэн саарал хайрцаг, дугуй өнцөг, тогтмол өндрийг унтраана —
 * `group-data-horizontal/tabs:h-8` нь бөмбөлгийн босоо зайг шахдаг.
 */
export const TAB_LIST =
  'flex h-auto w-fit max-w-full flex-wrap items-center gap-2 rounded-none border-0 bg-transparent p-0 group-data-horizontal/tabs:h-auto'

/**
 * Нэг таб.
 *
 * Энгийн нь цагаан, идэвхтэй нь цөцгий (`#fbead8`) дэвсгэртэй — эс тэгвээс
 * аль нь сонгогдсоныг ялгах боломжгүй. `after:hidden` нь үндсэн хэлбэрийн
 * доогуур зураасыг, `flex-none` нь тэгш сунгалтыг арилгана.
 */
export const TAB_TRIGGER = [
  'inline-flex h-auto flex-none items-center justify-center rounded-full px-5 py-2.5 text-xl font-medium transition after:hidden',

  // Идэвхгүй — цагаан
  'border border-[#dec7ae] bg-white text-black',
  'dark:border-[#dec7ae] dark:bg-white dark:text-black',
  'hover:bg-[#fdf6f0] hover:text-black dark:hover:bg-[#fdf6f0] dark:hover:text-black',

  // Идэвхтэй — цөцгий
  'data-active:border-[#dec7ae] data-active:bg-[#fbead8] data-active:text-black data-active:shadow-none',
  'dark:data-active:border-[#dec7ae] dark:data-active:bg-[#fbead8] dark:data-active:text-black'
].join(' ')
